import Service from "../../Services";

const Partner = {
  namespaced : true,
  state : {
    form : {
      branch_id : '',
      is_main_partner : false,
      name_th : '',
      name_en : '',
      image_path : '',
      image_path_show : '',
      image_name : '',
      orders : '',
      is_publish : true,
      url : '',
    }
  },
  mutations : {
    GET_FORM:(state,res)=>{
      state.form = res;
    },
    CLEAR_FORM_DATA :(state)=>{
      state.form = {
        branch_id : '',
        is_main_partner : false,
        name_th : '',
        name_en : '',
        image_path : '',
        image_path_show : '',
        image_name : '',
        orders : '',
        is_publish : true,
        url : '',
      }
    }
  },
  actions : {
    getPartner({commit},{page,search,sort_order}){
      return Service.PartnerAPI.getPartner(page,search,sort_order);
    },
    showPartner({commit},id){
      return Service.PartnerAPI.showPartner(id);
    },
    savePartner({commit},{id,data}){
      if(id){
        return Service.PartnerAPI.updatePartner(id,data);
      }else{
        return Service.PartnerAPI.createPartner(data);
      }
    },
    deletePartner({commit},id){
      return Service.PartnerAPI.deletePartner(id);
    },
    setFormPartner({commit},res){
      commit('GET_FORM',res);
    },
    clearFormData({commit}){
      commit('CLEAR_FORM_DATA');
    }
  },
}
export default Partner
